import { createFileRoute } from '@tanstack/react-router'
import { DayPassTypesCard } from '@/features/day-passes/components/day-pass-types-card'

export const Route = createFileRoute(
  '/_authenticated/memberships/day-pass-types'
)({
  component: MembershipsDayPassTypesView,
})

function MembershipsDayPassTypesView() {
  return <DayPassTypesCard />
}
